export default {
  name: 'sa-jukebox',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent'
  }
};
